import React from 'react';
import BackButton from 'components/Button/BackButton';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface PreviousStepButtonProps {
  setStep?: (value: React.SetStateAction<number>) => void;
  currentStep: number;
  disabledSteps?: string[];
  steps: string[];
  sx?: SxProps<Theme>;
}

const PreviousStepButton: React.FC<PreviousStepButtonProps> = ({ setStep, currentStep = 0, disabledSteps = [], steps, sx }) => {
  const previousStep: (current: number) => number = (current) => {
    let next = current;
    do {
      next--;
    } while (next > -1 && disabledSteps.includes(steps[next]));

    return next;
  };

  const goBack = (event: React.SyntheticEvent) => {
    setStep && setStep(previousStep);
  };

  const canGoBack = currentStep > 0 && previousStep(currentStep) > -1;

  return canGoBack ? <BackButton onClick={goBack} sx={sx} /> : null;
};

export default PreviousStepButton;
